/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : EditDetailsDialog.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import CustomDialogBoxV2 from "../../common/customDialogBox/CustomDialogBoxV2";
import CustomRadioButtonV2 from "../../common/radioButton/CustomRadioButtonV2";

function EditDetailsDialog({ openEditDetails, setOpenEditDetails, onClick }) {
  const [editValue, setEditValue] = React.useState("replace");

  return (
    <Box>
      <CustomDialogBoxV2
        open={openEditDetails}
        onClose={() => setOpenEditDetails(false)}
        title="Edit"
        successButtonName={"Next"}
        rejectButtonName={"Cancel"}
        onClickSuccess={() => onClick(editValue)}
        onClickReject={() => setOpenEditDetails(false)}
        actionButtonStyle={"continuous"}
      >
        <Box
          sx={{
            width: "350px",
            height: "70px",
            ml: 2,
            display: "flex",
            alignItems: "center",
          }}
        >
          <CustomRadioButtonV2
            value={editValue}
            displayDirection="column"
            onChange={(e) => {
              setEditValue(e.target.value);
            }}
            data={[
              { value: "replace", label: "Replace" },
              { value: "update", label: "Update" },
              {
                value: "updateAttribute",
                label: "Edit Attribute",
              },
            ]}
          />
        </Box>
      </CustomDialogBoxV2>
    </Box>
  );
}

EditDetailsDialog.propTypes = {
  openEditDetails: PropTypes.bool,
  setOpenEditDetails: PropTypes.func,
  onClick: PropTypes.func,
};

export default EditDetailsDialog;
